module.exports = __webpack_public_path__ + "media/images/cc-25-9a7f6609a8827e2f5bf4a897c23942ff.png";